<script setup lang="ts">
defineProps<{
  floating?: boolean
}>()
</script>

<template>
  <div class="viewer-pill" :class="{ 'viewer-pill--floating': floating }">
    <slot />
  </div>
</template>

<style scoped>
.viewer-pill {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 100%;
  padding: 3px 6px;
  border-radius: 12px;
  isolation: isolate;
}

.viewer-pill::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  border-radius: inherit;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transform-origin: top center;
}

.viewer-pill--floating {
  position: absolute;
  top: 8px;
  left: 8px;
  right: 8px;
  margin: 0 auto;
  width: fit-content;
  max-width: calc(100% - 16px);
  justify-content: center;
  gap: 6px 4px;
  padding: 4px 8px;
  z-index: 2;
}
</style>
